import React from "react";
import CustomMenu from "./Menu/CustomMenu";
import CustomBar from "./CustomBar";
import { Layout } from "react-admin";
import {UserProvider} from "../../context/userProvider";

const CustomLayout = (props) => {
  const { ...restProps } = props;
  return (
      <UserProvider>
        <Layout {...restProps} menu={CustomMenu} appBar={CustomBar} />
      </UserProvider>
  );
};

export default CustomLayout;
